/* unplugin-vue-components disabled */import { render } from "./ai-button.vue?vue&type=template&id=1e630790&scoped=true"
import script from "./ai-button.vue?vue&type=script&lang=js"
export * from "./ai-button.vue?vue&type=script&lang=js"

import "./ai-button.vue?vue&type=style&index=0&id=1e630790&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e630790"],['__file',"src/components/ai-chat-v2/ai-assistant/ai-input/ai-button.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1e630790"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1e630790', __exports__)) {
    api.reload('1e630790', __exports__)
  }
  
  module.hot.accept("./ai-button.vue?vue&type=template&id=1e630790&scoped=true", () => {
    api.rerender('1e630790', render)
  })

}


export default __exports__